import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_2 = {
  key: 0,
  class: "mas me-1"
}
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "manipulate-buttons d-flex justify-content-end align-items-center"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "edit", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "delete", -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIconIsActive = _resolveComponent("BaseIconIsActive")!
  const _component_MenusOverviewItemReferenceEdit = _resolveComponent("MenusOverviewItemReferenceEdit")!
  const _component_MenusOverviewItemReferenceInfo = _resolveComponent("MenusOverviewItemReferenceInfo")!
  const _component_MenusOverviewItemTarget = _resolveComponent("MenusOverviewItemTarget")!
  const _component_BaseMoveButtons = _resolveComponent("BaseMoveButtons")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MenusOverviewItem = _resolveComponent("MenusOverviewItem", true)!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", null, [
      _createElementVNode("td", {
        class: _normalizeClass(["status", this.tableCellClasses])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_BaseIconIsActive, {
            "is-active": this.menuItem.status_code === _ctx.StatusEnum.PUBLISHED
          }, null, 8, ["is-active"])
        ])
      ], 2),
      _createElementVNode("td", {
        class: _normalizeClass(["text", this.tableCellClasses])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass({'d-flex align-items-center me-1': this.isSubMenuItem})
        }, [
          (this.isSubMenuItem)
            ? (_openBlock(), _createElementBlock("i", _hoisted_2, "check_indeterminate_small"))
            : _createCommentVNode("", true),
          _createTextVNode(_toDisplayString(this.menuItem.menu_item_text), 1)
        ], 2)
      ], 2),
      _createElementVNode("td", {
        class: _normalizeClass(["reference-edit", this.tableCellClasses])
      }, [
        (this.hasPageReference && this.isReadyPageReference)
          ? (_openBlock(), _createBlock(_component_MenusOverviewItemReferenceEdit, {
              key: 0,
              "linked-content-page": this.linkedContentPage,
              "is-deleted": this.isDeletedContentPage,
              "is-not-published": this.isNotPublishedContentPage,
              "page-id": this.pageReference.page_id
            }, null, 8, ["linked-content-page", "is-deleted", "is-not-published", "page-id"]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("td", {
        class: _normalizeClass(["reference-info", this.tableCellClasses])
      }, [
        (this.hasPageReference && this.isReadyPageReference)
          ? (_openBlock(), _createBlock(_component_MenusOverviewItemReferenceInfo, {
              key: 0,
              "page-reference": this.pageReference
            }, null, 8, ["page-reference"]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("td", {
        class: _normalizeClass(["target", this.tableCellClasses])
      }, [
        (this.menuItem.page_reference?.target)
          ? (_openBlock(), _createBlock(_component_MenusOverviewItemTarget, {
              key: 0,
              target: this.menuItem.page_reference.target
            }, null, 8, ["target"]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("td", {
        class: _normalizeClass(["buttons", this.tableCellClasses])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_BaseMoveButtons, {
            onTop: _cache[0] || (_cache[0] = ($event: any) => (this.moveItem(this.menuItemId, _ctx.MoveActionEnum.TOP))),
            onUp: _cache[1] || (_cache[1] = ($event: any) => (this.moveItem(this.menuItemId, _ctx.MoveActionEnum.UP))),
            onDown: _cache[2] || (_cache[2] = ($event: any) => (this.moveItem(this.menuItemId, _ctx.MoveActionEnum.DOWN))),
            onBottom: _cache[3] || (_cache[3] = ($event: any) => (this.moveItem(this.menuItemId, _ctx.MoveActionEnum.BOTTOM)))
          }),
          (!this.isSubMenuItem)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_router_link, {
                  to: this.editRoute,
                  class: "btn btn-icon btn-primary ms-2"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (this.deleteItem(this.menuItemId)), ["prevent"])),
                  class: "btn btn-icon btn-danger ms-2"
                }, _hoisted_7)
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    (this.isReadySubMenu && this.hasSubMenu)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(this.subMenu, (subMenuItem) => {
          return (_openBlock(), _createBlock(_component_MenusOverviewItem, {
            key: subMenuItem.id,
            "menu-id": this.menuItemId,
            "full-menu-item": subMenuItem,
            "is-sub-menu-item": "",
            onExceptions: this.setExceptions,
            onDelete: this.deleteItem,
            onMove: this.moveItem
          }, null, 8, ["menu-id", "full-menu-item", "onExceptions", "onDelete", "onMove"]))
        }), 128))
      : _createCommentVNode("", true)
  ], 64))
}